import ErrorValidation from '../personalized/error-validation'
import { __ } from '../../../locales'

const urlRegex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/)

const LinkFilter = ({ inputs, onInputsChange, required, hidden = false }) => {
    if (hidden) {
        return null
    }
    return (
        <div className={'input-component'}>
            <label>{__('inputs.url.label')}:</label>
            <input
                type="text"
                className="form-control"
                value={inputs.linkUrl}
                placeholder={required ? 'Add link here' : __('global.optional')}
                onInput={(ev) => onInputsChange('linkUrl', ev.target.value)}
            />
            {(required && !inputs.linkUrl) || (inputs.linkUrl && !inputs.linkUrl.match(urlRegex)) ? (
                <ErrorValidation text={inputs.linkUrl.match(urlRegex) ? null : 'Invalid url'} />
            ) : null}
        </div>
    );
};

export default LinkFilter;
